import React from 'react'

import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'

const CoverSection = () => (
  <View id="5">
    <Text bold size="small">
      5. RESPONSABILIDADES
    </Text>

    <Separator weight={8} />

    <Text bold size="small">
      5.1. PELA AGÊNCIA/PROGRAMA
    </Text>

    <ul>
      <li>
        <Text>
          Fornecer ao Responsável Técnico pela Vistoria as informações das atividades executadas no local de trabalho
          para a realização da Análise Ergonômica do Trabalho Preliminar (AEP) e Análise Ergonômica do Trabalho (AET);
        </Text>
      </li>

      <li>
        <Text>
          Comunicar ao Responsável Técnica Unimed (área de SESMT: Segurança do Trabalho da Unimed{' '}
          {'<rhsegurancatrabalho@unimed.com.br>'}) as alterações nas atividades executadas no local de trabalho;
        </Text>
      </li>

      <li>
        <Text>
          Comunicar ao Responsável Técnica Unimed (área de SESMT: Segurança do Trabalho da Unimed{' '}
          {'<rhsegurancatrabalho@unimed.com.br>'}) a ocorrência de acidentes para a investigação das causas/motivos;
        </Text>
      </li>
    </ul>

    <Separator weight={8} />

    <Text bold size="small">
      5.2. PELA VISTORIA TÉCNICA
    </Text>

    <ul>
      <li>
        <Text>
          Realizar a AET de acordo com as informações prestadas pelo SESMT: Segurança do Trabalho da Unimed e pelo
          responsável pelo programa;
        </Text>
      </li>

      <li>
        <Text>Executar o enquadramento e avaliação de riscos ergonômicos;</Text>
      </li>

      <li>
        <Text>
          Recomendar meios para prevenção, adaptação e controle dos riscos ergonômicos constantes no ambiente de
          trabalho.
        </Text>
      </li>
    </ul>

    <Separator weight={8} />

    <Text bold size="small">
      5.3 - FUNCIONÁRIOS DA UNIMED
    </Text>

    <ul>
      <li>
        <Text>
          Colaborar e participar da implantação e manutenção da AET e seguir as orientações do responsável pelo
          programa;
        </Text>
      </li>

      <li>
        <Text>
          Avisar de imediato ao responsável pelo programa caso exista ocorrências que possam implicar em risco à saúde,
          assim como a ocorrência de acidentes;
        </Text>
      </li>

      <li>
        <Text>Conhecer e divulgar as normas e instruções sobre segurança e saúde;</Text>
      </li>

      <li>
        <Text>
          Participar dos cursos/treinamentos, exames médicos e campanhas de monitoramentos realizados pelo <b>UNIMED</b>
        </Text>
      </li>
    </ul>

    <Separator weight={8} />

    <Text bold size="small">
      5.4. PELO SESMT UNIMED:
    </Text>

    <ul>
      <li>
        <Text>
          Planejar as vistorias e eliminar/minimizar os impactos dos riscos existentes aos trabalhadores e ao ambiente,
          utilizando as ferramentas de análise de risco padronizadas;
        </Text>
      </li>

      <li>
        <Text>
          Auxiliar o responsável pelo programa com os canais/procedimentos existentes para atendimento de sua
          solicitação;
        </Text>
      </li>

      <li>
        <Text>
          Investigar os acidentes, elaborar e pôr em prática procedimentos específicos, incluindo atribuições a todos
          que possam vir a participar nas investigações;
        </Text>
      </li>

      <li>
        <Text>
          Emitir parecer conclusivo sobre as causas dos acidentes e medidas aplicáveis para prevenir ocorrências
          semelhantes;
        </Text>
      </li>

      <li>
        <Text>
          Manter registro de acidentes e todos os detalhes necessários aos estudos estatísticos e funcionais, da
          prevenção de acidentes e
        </Text>
      </li>

      <li>
        <Text>
          Elaborar programas e ministrar treinamentos de segurança e medicina do trabalho e promover campanhas de
          prevenção de acidentes e higiene do trabalho.
        </Text>
      </li>
    </ul>

    <Separator weight={8} />

    <Text bold size="small">
      5.5 - UNIMED
    </Text>

    <ul>
      <li>
        <Text>
          Apoiar a implantação, manutenção e desenvolvimento da AET, das atividades prevencionistas e de normas,
          instruções e programas que facilitem o seu desenvolvimento;
        </Text>
      </li>

      <li>
        <Text>
          Garantir a eliminação/controle dos riscos ergonômicos nos locais de trabalho, desde que identificados na AET
          e/ou informados pelo responsável pelo programa;
        </Text>
      </li>
    </ul>

    <Separator weight={8} />
  </View>
)

export default CoverSection
